
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'


export default {
name: 'Confirm',
directives: {
TransferDom
},
components: {
Popup
},
props: {
title: String,
conten: String
},
data () {
return {}
},
methods: {
onConfirm () {
this.$emit('handleConfirm')
},
onCancel () {
this.$emit('handleCancel')
}
}
}




// WEBPACK FOOTER //
// ./src/components/confirm/confirm.vue